import React from 'react';
import PropTypes from 'prop-types';

import { VpInput } from '../../inputs';

export const VpMediaNameInput = ({ value = '' }) => {
  return <VpInput disabled name="fileName" value={value} label="File Name" />;
};

VpMediaNameInput.propTypes = {
  value: PropTypes.string
};

export default VpMediaNameInput;



// WEBPACK FOOTER //
// ./src/vp-ui/form-fields/media-details/VpMediaNameInput.jsx